module.exports = "<nav class=\"anonymous\">\r\n  <div class=\"side-menu-anonymous\">\r\n    <login-form model=\"$ctrl.model\"\r\n                forgot-username=\"$ctrl.forgotUsername\"\r\n                api=\"$ctrl.api.loginForm\"\r\n                config=\"$ctrl.config\"></login-form>\r\n  </div>\r\n</nav>\r\n<rw-app-version>\r\n</rw-app-version>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/app/components/side-menu/side-menu-anonymous.html
// module id = 2149
// module chunks = 0